import React from "react";
import SubmitControl from "../SubmitControl/SubmitControl";

const Tag = props => {
  let handleTagsChange = props.handleTagsChange;
  return (
    <SubmitControl
      type="tags"
      value={props.tags}
      onChange={handleTagsChange}
      disabled={props.disabled}
      renderTag={props.renderTag}
      renderLayout={props.renderLayout}
    />
  );
};

export default Tag;
